import React from 'react';
import { Link } from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory , { PaginationProvider, PaginationTotalStandalone,SizePerPageDropdownStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
import Button from '../Form/Button';

import './ClassRecommendations.css';

const ClassRecommendations = props => {

  const defaultSorted=[{dataField: 'rank',order: 'asc'}];

    const classLinkFormatter = (cell, row) =>{  
        return (
          <Link to={`/classes/${row.classid}`}> { cell } </Link>   
        );
      } 
      const datasetLinkFormatter = (cell, row) =>{  
        return (
          <Link to={`/datasets/${row.datasetid}`}> { cell } </Link>  
        );
      } 
      const exportLinkFormatter = (cell, row) =>{  
        return (
          <div className="exportDiv">
         {props.format==="endpoint" && <Button href={`${process.env.REACT_APP_BACKEND_API_URL}/recommender/silk/${row.classid}/${encodeURIComponent(props.dataset)}/${encodeURIComponent(props.cs)}`} target='new' title="Silk-LSL file"className='exportBtn'>S</Button>}
         {props.format==="endpoint" &&<Button href={`${process.env.REACT_APP_BACKEND_API_URL}/recommender/limes/${row.classid}/${encodeURIComponent(props.dataset)}/${encodeURIComponent(props.cs)}/${encodeURIComponent(props.ontology)}`} target='new' title="LIMES web service" className='exportBtn'>L</Button>}
         {props.format!=="endpoint" && 'N/A'}
          </div>
        );
      } 
  
    const columns = [{
        dataField: 'class',
        text: 'Label',
        headerAlign: 'center',
        filter: textFilter(),
        formatter: classLinkFormatter,
        sort: true,
        style: {'wordWrap': 'break-word' },
        headerStyle: (colum, colIndex) => {
            return { width: '20%', 'wordWrap': 'break-word'  };
          }
      }, {
        dataField: 'uri',
        text: 'URI',
        headerAlign: 'center',
        sort: true,
        style: {'wordWrap': 'break-word' },
        headerStyle: (colum, colIndex) => {
            return { width: '40%', 'wordWrap': 'break-word'  };
          }
      }, {
        dataField: 'dataset',
        text: 'Dataset',
        headerAlign: 'center',
        sort: true,
        filter: textFilter(),
        style: {'wordWrap': 'break-word' },
        formatter: datasetLinkFormatter,
        headerStyle: (colum, colIndex) => {
            return { width: '15%', 'wordWrap': 'break-word'  };
          }
      }, {
        dataField: 'commoncells',
        text: 'Est. Related Instances',
        align: 'right',
        type: 'number',
        headerAlign: 'center',
        sort: true,
       // sortValue: (cell, row) => parseInt[cell],
        //formatter: commoncellsLinkFormatter,
        style: {'wordWrap': 'break-word' },
        headerStyle: (colum, colIndex) => {
            return { width: '10%', 'wordWrap': 'break-word'  };
          }
      }, {
        dataField: 'rank',
        text: 'Rank',
        align: 'right',
        type: 'number',
        headerAlign: 'center',
        sort: true,
    //    formatter: degreeLinkFormatter,
        style: {'wordWrap': 'break-word' },
        headerStyle: (colum, colIndex) => {
            return { width: '10%', 'wordWrap': 'break-word' };
          }
      },
      {
        dataField: 'df1',
        text: 'Link Discovery',
        isDummyField: true,
        align: 'center',
        headerAlign: 'center',
        style: {'wordWrap': 'break-word' },
        formatter: exportLinkFormatter,
        headerStyle: (colum, colIndex) => {
            return { width: '10%', 'wordWrap': 'break-word' };
          }
      }
    ];

    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
          &nbsp;Showing { from } to { to } of { size } classes
        </span>
      );

    const options = {
        custom: true,
        paginationTotalRenderer: customTotal,
        totalSize: props.recs.length
      };

     return (
         <div className="ClassRecommendationsList">
          <h3>Recommendations</h3>
          {props.recs.length===0 && <p>No recommendations for this class</p>}
          {props.recs.length>0 &&   <PaginationProvider pagination={ paginationFactory(options) }>
        {({paginationProps,paginationTableProps}) => (
        <div>
             <SizePerPageDropdownStandalone { ...paginationProps } />
             <PaginationTotalStandalone { ...paginationProps } />
            <PaginationListStandalone { ...paginationProps }/>
        
            <BootstrapTable
           
            keyField="id"
            data={ props.recs }
            columns={ columns } defaultSorted={defaultSorted}
            striped hover  filter={ filterFactory() }
          { ...paginationTableProps }
        />  
        {props.recs.length>10 && <SizePerPageDropdownStandalone { ...paginationProps } />}
        {props.recs.length>10 &&      <PaginationTotalStandalone { ...paginationProps } />}
         {props.recs.length>10 &&     <PaginationListStandalone { ...paginationProps }/>}
        
        </div>
        )
        }
        </PaginationProvider>}
            </div>
     );
};

export default ClassRecommendations;